import "./normalTextStyle.css"

export default function NormalText({text}) {
    return (
        <p className="normal-text">{text}</p>
    );
}